<template>
  <span :style="componentStyle">
    <span
      :style="`gap: var(--spacing-${spacing})`"
      :class="`size-${size} display-inline-flex flex-row flex-items-center`"
    >
      <font-awesome-icon
        v-for="index in length"
        :key="index"
        :icon="$v7.solid[iconName]"
        class="fa-width-auto"
      />
    </span>
  </span>
</template>

<script>
  export default {
    name: 'ObfuscatedText',

    props: {
      customStyle: {
        type: Object,
        default: () => {}
      },
      iconName: {
        type: String,
        default: 'faCircleSmall'
      },
      length: {
        type: Number,
        required: true,
        default: 15
      },
      size: {
        type: String,
        default: 'xs'
      },
      spacing: {
        type: String,
        default: 'xs'
      }
    },

    computed: {
      componentStyle() {
        return {
          ...this.customStyle
        }
      }
    }
  }
</script>
